import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _wrapNativeSuper from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */
export var ArgumentNullError = /*#__PURE__*/function (_Error) {
  _inherits(ArgumentNullError, _Error);

  /**
   * Creates an instance of ArgumentNullError.
   *
   * @param {string} argumentName - Name of the argument that is null
   *
   * @memberOf ArgumentNullError
   */
  function ArgumentNullError(argumentName) {
    var _this;

    _classCallCheck(this, ArgumentNullError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ArgumentNullError).call(this, argumentName));
    _this.name = "ArgumentNull";
    _this.message = argumentName;
    return _this;
  }

  return ArgumentNullError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * The error that is thrown when an invalid operation is performed in the code.
 *
 * @export
 * @class InvalidOperationError
 * @extends {Error}
 */
// tslint:disable-next-line:max-classes-per-file

export var InvalidOperationError = /*#__PURE__*/function (_Error2) {
  _inherits(InvalidOperationError, _Error2);

  /**
   * Creates an instance of InvalidOperationError.
   *
   * @param {string} error - The error
   *
   * @memberOf InvalidOperationError
   */
  function InvalidOperationError(error) {
    var _this2;

    _classCallCheck(this, InvalidOperationError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(InvalidOperationError).call(this, error));
    _this2.name = "InvalidOperation";
    _this2.message = error;
    return _this2;
  }

  return InvalidOperationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * The error that is thrown when an object is disposed.
 *
 * @export
 * @class ObjectDisposedError
 * @extends {Error}
 */
// tslint:disable-next-line:max-classes-per-file

export var ObjectDisposedError = /*#__PURE__*/function (_Error3) {
  _inherits(ObjectDisposedError, _Error3);

  /**
   * Creates an instance of ObjectDisposedError.
   *
   * @param {string} objectName - The object that is disposed
   * @param {string} error - The error
   *
   * @memberOf ObjectDisposedError
   */
  function ObjectDisposedError(objectName, error) {
    var _this3;

    _classCallCheck(this, ObjectDisposedError);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ObjectDisposedError).call(this, error));
    _this3.name = objectName + "ObjectDisposed";
    _this3.message = error;
    return _this3;
  }

  return ObjectDisposedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));